import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { Loading } from '@leapeasy/ui-kit';
import { GlobalUXState } from 'components/GlobalUXState';

const SLOW_LOADING_MS = 3000;

export const DetailPageLoadingCenter = ({
  minHeight = 240,
  label = 'Loading...',
  showSlowLoadingHint = true,
  compact = false,
}) => {
  const [showSlowHint, setShowSlowHint] = useState(false);

  useEffect(() => {
    if (!showSlowLoadingHint) {
      setShowSlowHint(false);
      return undefined;
    }
    const timer = setTimeout(() => setShowSlowHint(true), SLOW_LOADING_MS);
    return () => {
      clearTimeout(timer);
      setShowSlowHint(false);
    };
  }, [showSlowLoadingHint]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      gap="16px"
      minHeight={`${minHeight}px`}
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={label}
    >
      <Loading size={compact ? 'medium' : 'large'} label={label} isPathVisible />
      {showSlowHint ? <GlobalUXState variant="slowLoading" compact /> : null}
    </Box>
  );
};
